(() => {
  'use strict';
  const page = document.querySelector('[data-water-quality-page]');
  const sticky = page?.querySelector('[data-water-quality-sticky]');
  const heroCta = page?.querySelector('[data-water-quality-hero-cta]');
  const finalCta = page?.querySelector('[data-water-quality-final-cta]');
  if (!page || !sticky || !heroCta || !finalCta) return;

  const mobile = matchMedia('(max-width: 749px)');
  let heroVisible = true;
  let finalVisible = false;
  let completed = false;
  try { completed = sessionStorage.getItem('luscentra_water_quality_completed') === 'true'; } catch {}

  const update = () => {
    const modalOpen = document.body.classList.contains('lus-water-open');
    const visible = mobile.matches && !heroVisible && !finalVisible && !modalOpen && !completed;
    sticky.hidden = !mobile.matches;
    sticky.classList.toggle('is-visible', visible);
    sticky.setAttribute('aria-hidden', String(!visible));
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target === heroCta) heroVisible = entry.isIntersecting;
      if (entry.target === finalCta) finalVisible = entry.isIntersecting;
    });
    update();
  }, { threshold: 0.2 });

  observer.observe(heroCta);
  observer.observe(finalCta);
  new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  mobile.addEventListener?.('change', update);
  window.addEventListener('luscentra:water_contact_submit', () => {
    completed = true;
    try { sessionStorage.setItem('luscentra_water_quality_completed', 'true'); } catch {}
    update();
  });
  update();
})();
